export enum RedeemFlipmeCardsStepsEnum {
  STEP1 = 1,
  STEP2,
  STEP3,
  STEP4
}
